(function(){
  class NakushimaCartDrawer extends HTMLElement{
    constructor(){
      super();
      this.sectionId = this.dataset.sectionId;
      this.bound = false;
    }

    connectedCallback(){
      this.bindOnce();
      this.bindGiftControls();
    }

    bindOnce(){
      if(this.bound) return;
      this.bound = true;

      this.addEventListener('click', async (e) => {
        if(e.target.closest('[data-close]')){
          e.preventDefault();
          this.close();
          return;
        }

        const li = e.target.closest('[data-line-item]');

        if(li && e.target.closest('[data-remove]')){
          e.preventDefault();
          await this.updateItemQuantity(li.dataset.key, li.dataset.variantId, 0);
          return;
        }

        if(li && e.target.closest('[data-qty-inc]')){
          e.preventDefault();
          await this.updateItemDelta(li.dataset.key, li.dataset.variantId, 1);
          return;
        }

        if(li && e.target.closest('[data-qty-dec]')){
          e.preventDefault();
          await this.updateItemDelta(li.dataset.key, li.dataset.variantId, -1);
          return;
        }

        const upsellBtn = e.target.closest('[data-upsell-add]');
        if(upsellBtn){
          e.preventDefault();

          const card = upsellBtn.closest('[data-upsell-card]');
          const id = card?.dataset.variantId;

          if(id){
            await this.addVariant(id, 1, true);
          }
        }
      });

      document.addEventListener('click', async (e) => {
        const trigger = e.target.closest('a[href$="/cart"], a[href="#cart"], [data-cart-open]');

        if(!trigger) return;

        e.preventDefault();
        await this.refreshAndOpen();
      });
    }

    bindGiftControls(){
      const toggle = this.querySelector('[data-gift-toggle]');
      const panel = this.querySelector('[data-gift-panel]');
      const text = this.querySelector('[data-gift-text]');
      const len = this.querySelector('[data-gift-len]');
      const attr = this.querySelector('[data-gift-attr]');

      if(!toggle) return;

      if(panel){
        panel.hidden = !toggle.checked;
      }

      toggle.addEventListener('change', async () => {
        if(panel){
          panel.hidden = !toggle.checked;
        }

        if(!toggle.checked){
          if(attr) attr.value = '';
          if(text) text.value = '';
          if(len) len.textContent = '0';

          await this.updateAttribute('Gavehilsen', '');
        }
      });

      text?.addEventListener('input', () => {
        if(len) len.textContent = text.value.length;
        if(attr) attr.value = text.value;
      });

      text?.addEventListener('blur', async () => {
        await this.updateAttribute('Gavehilsen', text.value);
      });
    }

    open(){
      this.hidden = false;
      this.classList.remove('is-closing');
      document.body.style.overflow = 'hidden';
    }

    close(){
      this.classList.add('is-closing');

      setTimeout(() => {
        this.hidden = true;
        this.classList.remove('is-closing');
        document.body.style.overflow = '';
      }, 350);
    }

    async refreshAndOpen(){
      await this.rerender();
      this.open();
    }

    async replaceFromSectionsResponse(data){
      const html = data.sections && data.sections[this.sectionId];

      if(!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('nakushima-cart-drawer');

      if(!fresh) return;

      this.innerHTML = fresh.innerHTML;

      Array.from(fresh.attributes).forEach((attr) => {
        if(['hidden','class','id'].includes(attr.name)) return;
        this.setAttribute(attr.name, attr.value);
      });

      this.bindGiftControls();
      this.open();
    }

    /*
      Underretter temaets egen header-cart-icon (Horizon) om at kurven er
      ændret. Den lytter kun efter det globale 'cart:update'-event, ikke
      vores egne 'cart:updated'/'cart:add', så uden dette forbliver
      kurv-badge'et i headeren forkert efter fx addVariant med openAfter:false.
    */
    notifyHeaderCart(cart){
      if(!cart) return;

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'nakushima-cart-drawer',
          data: { itemCount: cart.item_count }
        }
      }));
    }

    async changeByKey(key, quantity){
      if(!key) return;

      const res = await fetch('/cart/change.js', {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          id:key,
          quantity:Number(quantity),
          sections:[this.sectionId],
          sections_url:window.location.pathname
        })
      });

      const data = await res.json();
      this.notifyHeaderCart(data);
      await this.replaceFromSectionsResponse(data);
    }

    async changeByKeyDelta(key, delta){
      if(!key) return;

      const cartRes = await fetch('/cart.js', {
        headers:{ 'Accept':'application/json' }
      });

      const cart = await cartRes.json();

      const item = cart.items.find(function(i){
        return i.key === key;
      });

      if(!item) return;

      const nextQty = Math.max(0, Number(item.quantity) + Number(delta));

      await this.changeByKey(key, nextQty);
    }

    async changeByVariant(variantId, quantity){
  if(!variantId) return;

  const cartRes = await fetch('/cart.js', {
    headers:{ 'Accept':'application/json' }
  });

  const cart = await cartRes.json();

  const item = cart.items.find(function(i){
    return String(i.variant_id) === String(variantId);
  });

  if(!item) return;

  await this.changeByKey(item.key, quantity);
}

async changeByVariantDelta(variantId, delta){
  if(!variantId) return;

  const cartRes = await fetch('/cart.js', {
    headers:{ 'Accept':'application/json' }
  });

  const cart = await cartRes.json();

  const item = cart.items.find(function(i){
    return String(i.variant_id) === String(variantId);
  });

  if(!item) return;

  const nextQty = Math.max(0, Number(item.quantity) + Number(delta));

  await this.changeByKey(item.key, nextQty);
}
    async updateItemQuantity(key, variantId, quantity){
      const cartRes = await fetch('/cart.js', {
        headers:{ 'Accept':'application/json' }
      });

      const cart = await cartRes.json();
      const updates = {};

      cart.items.forEach(function(item){
        updates[item.key] = item.quantity;
      });

      let target = cart.items.find(function(item){
        return item.key === key;
      });

      if(!target){
        target = cart.items.find(function(item){
          return String(item.variant_id) === String(variantId);
        });
      }

      if(!target) return;

      updates[target.key] = Number(quantity);

      const res = await fetch('/cart/update.js', {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          updates:updates,
          sections:[this.sectionId],
          sections_url:window.location.pathname
        })
      });

      const data = await res.json();
      this.notifyHeaderCart(data);
      await this.replaceFromSectionsResponse(data);
    }

    async updateItemDelta(key, variantId, delta){
      const cartRes = await fetch('/cart.js', {
        headers:{ 'Accept':'application/json' }
      });

      const cart = await cartRes.json();

      let target = cart.items.find(function(item){
        return item.key === key;
      });

      if(!target){
        target = cart.items.find(function(item){
          return String(item.variant_id) === String(variantId);
        });
      }

      if(!target) return;

      const nextQty = Math.max(0, Number(target.quantity) + Number(delta));

      await this.updateItemQuantity(target.key, target.variant_id, nextQty);
    }
    async addVariant(variantId, quantity = 1, openAfter = true){
      if(!variantId) return;

      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          id:Number(variantId),
          quantity:Number(quantity),
          sections:[this.sectionId],
          sections_url:window.location.pathname
        })
      });

      const data = await res.json();

document.dispatchEvent(new CustomEvent('cart:updated', {
  detail: data
}));

document.dispatchEvent(new CustomEvent('cart:add', {
  detail: data
}));

/*
  /cart/add.js svarer kun med den tilføjede linje, ikke hele kurven, så
  vi henter kurven separat for at kunne opdatere header-badge'et korrekt
  (se notifyHeaderCart).
*/
try{
  const cartRes = await fetch('/cart.js', { headers:{ 'Accept':'application/json' } });
  const cart = await cartRes.json();
  this.notifyHeaderCart(cart);
} catch(err){
  // Badge kunne ikke opdateres, men varen er allerede lagt i kurven
}

      if(data.sections && data.sections[this.sectionId]){
        const doc = new DOMParser().parseFromString(data.sections[this.sectionId], 'text/html');
        const fresh = doc.querySelector('nakushima-cart-drawer');

        if(fresh){
          this.innerHTML = fresh.innerHTML;
          this.bindGiftControls();
        }
      }

      if(openAfter){
        this.open();
      }
    }

    async updateAttribute(name, value){
      await fetch('/cart/update.js', {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          attributes:{
            [name]:value
          }
        })
      });
    }

    async rerender(){
      if(!this.sectionId) return;

      const res = await fetch(`${window.location.pathname}?sections=${this.sectionId}`, {
        headers:{
          'Accept':'application/json'
        }
      });

      if(!res.ok) return;

      const data = await res.json();
      const html = data[this.sectionId];

      if(!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('nakushima-cart-drawer');

      if(!fresh) return;

      this.innerHTML = fresh.innerHTML;

      Array.from(fresh.attributes).forEach((attr) => {
        if(['hidden','class','id'].includes(attr.name)) return;
        this.setAttribute(attr.name, attr.value);
      });

      this.bindGiftControls();
    }
  }

  if(!customElements.get('nakushima-cart-drawer')){
    customElements.define('nakushima-cart-drawer', NakushimaCartDrawer);
  }

  window.NakushimaCart = {
    open(){
      document.querySelector('nakushima-cart-drawer')?.open();
    },

    close(){
      document.querySelector('nakushima-cart-drawer')?.close();
    },

    refresh(){
      return document.querySelector('nakushima-cart-drawer')?.rerender();
    },

    refreshAndOpen(){
      return document.querySelector('nakushima-cart-drawer')?.refreshAndOpen();
    }
  };
})();